import '@/utils/polyfill';
import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import vueMoment from 'vue-moment';
import moment from 'moment-timezone';
import { i18n } from '@/plugins/lang';
import VueSanitize from 'vue-sanitize';
import { extend, ValidationProvider, ValidationObserver, configure } from 'vee-validate';
import { alpha_num, email, required } from 'vee-validate/dist/rules';
import { checkIsZenkaku } from '@/utils/njValidation';

Vue.use(VueSanitize);
Vue.config.productionTip = false;
Vue.use(vueMoment, { moment });
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);

const vueControl = () => {
  window.onStartInfaceAuth = () => {
    new Vue({
      el: '#app',
      i18n,
      router,
      store,
      template: '<App/>',
      components: {
        App,
      },
      created() {
        var EOSBrowserSupport = window.EOSBrowserSupport;
        EOSBrowserSupport.create(null);
      },
    });
  };
  window.onErrorInfaceAuth = (error) => {
    console.error('onErrorInfaceAuth', error);
  };
};

// vee-validate config & rules (only use for NJ auth form)
configure({
  classes: {
    invalid: 'is-invalid',
  },
});

extend('email', {
  ...email,
  message: '! メールアドレスが正しくありません。',
});

// 반각: 영어, 숫자, 기호
extend('bankakuChr', (value) => {
  if (/^[a-zA-Z0-9\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]+$/.test(value)) {
    return true;
  }
  return '! メールアドレスが正しくありません。';
});

// 반각: 숫자, 슬래시 기호(/)
extend('birthday', (value) => {
  if (!moment(String(value), 'YYYYMMDD', true).isValid() || moment(String(value)).isAfter(moment(), 'day')) {
    return '! 日付が正しくありません。';
  }
  if (/^[0-9/]+$/.test(value)) {
    return true;
  }
  return '! 半角数字で入力してください。';
});

// 전각: 히라가나, 카타카나, 한자, 대시 기호(－), 숫자
extend('zenkakuChrNumHypen', (value) => {
  if (checkIsZenkaku(value) && /^[ぁ-ゔァ-ヴー々〆〤一-龥－０-９]+$/.test(value)) {
    return true;
  }
  return '! 全角で入力してください。';
});

// 전각 + 6개 특정 기호 (＆’，‐．・)
extend('zenkakuChr', (value) => {
  if (checkIsZenkaku(value) || /^[＆’，‐．・]+$/.test(value)) {
    return true;
  }
  return '! 全角で入力してください。';
});

// 전각: 히라가나, 카타카나, 한자, 영어
extend('zenkakuChrIncludingEng', (value) => {
  if (checkIsZenkaku(value) && /^[ぁ-ゔァ-ヴー々〆〤一-龥ａ-ｚＡ-Ｚ]+$/.test(value)) {
    return true;
  }
  return '! 全角で入力してください。';
});

// 전각 카타카나
extend('zenkakuKata', (value) => {
  if (checkIsZenkaku(value) && /^[ァ-ヴー々〆〤]+$/.test(value)) {
    return true;
  }
  return '! 全角カタカナで入力してください。';
});

// 반각: 영문, 숫자
extend('alpha_num', {
  ...alpha_num,
  message: '! 半角英数字で入力してください。',
});

extend('required_if', {
  ...required,
  message: '! 必須値です',
});
extend('required', {
  ...required,
  message: '! 必須値です',
});

vueControl();
